<template>
  <b-container>
    <b-row>
      <b-col>
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          size="sm"
          @click.prevent="viewSanction"
          variant="warning"
          v-if="
            ApplicationStatus == 6 ||
            ApplicationStatus == 16 ||
            ApplicationStatus == 8 ||
            ApplicationStatus == 9 ||
            ApplicationStatus == 11
          "
          >Sanction Letter</b-button
        >
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          size="sm"
          @click.prevent="printLoi"
          variant="success"
          v-if="
            ApplicationStatus == 16 ||
            ApplicationStatus == 6 ||
            ApplicationStatus == 8 ||
            ApplicationStatus == 9 ||
            ApplicationStatus == 10 ||
            ApplicationStatus == 11 ||
            ApplicationStatus >= 23 && ApplicationStatus <=29
          "
          >LOI</b-button
        >
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          size="sm"
          @click.prevent="printLoiOld"
          variant="success"
          v-if="ApplicationStatus == 27"
          >PREVIOUS LOI</b-button
        >
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          size="sm"
          @click.prevent="extendLoi"
          variant="warning"
          v-if="(ApplicationStatus==6 || ApplicationStatus==8 || ApplicationStatus==9 || ApplicationStatus==10 || ApplicationStatus==11 || (ApplicationStatus>=23 && ApplicationStatus<=29)) && (RoleID==3 || RoleID==4 || RoleID==5 || RoleID==6 || RoleID==10)"
        >Extend LOI</b-button>
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          size="sm"
          variant="info"
          @click="print"
          >Print Profile</b-button
        >
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          @click.prevent="goback"
          variant="secondary"
          size="sm"
          >BACK</b-button
        >
      </b-col>
    </b-row>
    <div id="printme">
      <div class="application-view">
        <div class="reg-form-box">
          <div class="reg-form-body">
            <b-container class="bv-example-row">
              <b-row>
                <b-col offset="1">
                  <h5 class="reg-form-title text-primary ml-4">
                    Application No:
                    {{ personalDetails.LoanApplication[0].LoanApplicationNo }}
                  </h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="8" offset="1">
                  <b-container class="bv-example-row">
                    <h5 class="reg-form-title text-primary">
                      Personal Details
                    </h5>
                    <table
                      class="profile-table table-3x"
                      style="margin-left: 0"
                    >
                      <tbody>
                        <tr>
                          <td colspan="3">
                            <span class="bold">Applicant Name:</span>
                            {{ personalDetails.FirstName }}
                            {{ personalDetails.MiddleName }}
                            {{ personalDetails.LastName }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Date Of Birth:</span>
                            {{ personalDetails.DOB }}
                          </td>
                          <td>
                            <span class="bold">Aadhar Id:</span>
                            {{ personalDetails.AdharNo }}
                          </td>
                          <td>
                            <span class="bold">PAN No.:</span>
                            {{ personalDetails.PanCardNo }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Gender:</span>
                            <span v-if="personalDetails.Gender">Male</span>
                            <span v-else>Female</span>
                          </td>
                          <td>
                            <span class="bold">Email:</span>
                            {{ personalDetails.EmailID }}
                          </td>
                          <td>
                            <span class="bold">Mobile No.:</span>
                            {{ personalDetails.MobileNo }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Married Status:</span>
                            <span v-if="personalDetails.MaritalStatus"
                              >Married</span
                            >
                            <span v-else>Unmarried</span>
                          </td>
                          <td>
                            <span class="bold">Nationality:</span>
                            <span v-if="personalDetails.Nationality"
                              >Indian</span
                            >
                            <span v-else>Non-Indian</span>
                          </td>
                          <td>
                            <span class="bold">Maharashtra Domicile:</span>
                            <span v-if="personalDetails.Domiciled">Yes</span>
                            <span v-else>No</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Ration Card:</span>
                            <span>{{ personalDetails.RationCardNo }}</span>
                          </td>
                          <td>
                            <span class="bold">Family Income:</span>
                            <span>{{ personalDetails.FamilyIncome }}</span>
                          </td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="3">
                            <span class="bold">Caste:</span>
                            <span>{{ personalDetails.CasteName }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-container>
                </b-col>
                <b-col cols="2">
                  <b-container class="bv-example-row">
                    <b-row>
                      <b-col>
                        <img
                          style="width: 120px; height: auto"
                          :src="
                            getImgUrl(
                              personalDetails.UserLoanDocuments.PhotoPath
                            )
                          "
                        />
                      </b-col>
                    </b-row>
                    <!-- <b-row>
                      <b-col>
                        <img
                          style="width:120px;height:auto"
                          :src="getImgUrl(personalDetails.UserLoanDocuments.SignaturePath)"
                        >
                      </b-col>
                    </b-row>-->
                  </b-container>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </div>
      </div>

      <!-- ******** -->
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Address Details</h5>

                  <table class="profile-table table-3x" style="margin-left: 0">
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">House No:</span>
                          {{ personalDetails.CorrespondenceAddress.HouseNo }}
                        </td>
                        <td>
                          <span class="bold">Building No:</span>
                          {{ personalDetails.CorrespondenceAddress.BuildingNo }}
                        </td>
                        <td>
                          <span class="bold">Landmark:</span>
                          {{ personalDetails.CorrespondenceAddress.Landmark }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Village:</span>
                          {{ personalDetails.CorrespondenceAddress.Village }}
                        </td>
                        <td>
                          <span class="bold">Taluka:</span>
                          {{ personalDetails.CorrespondenceAddress.TalukaName }}
                        </td>
                        <td>
                          <span class="bold">District:</span>
                          {{
                            personalDetails.CorrespondenceAddress.DistrictName
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Post:</span>
                          {{ personalDetails.CorrespondenceAddress.Post }}
                        </td>
                        <td>
                          <span class="bold">State:</span>
                          {{ personalDetails.CorrespondenceAddress.StateName }}
                        </td>
                        <td>
                          <span class="bold">Pincode:</span>
                          {{ personalDetails.CorrespondenceAddress.Pincode }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <!-- family details starts here -->
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="3"></b-col>
              <b-col cols="9" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Family Details</h5>
                  <table
                    class="profile-table info-table"
                    style="margin-left: 0"
                  >
                    <tbody>
                      <tr>
                        <th class="bold">Full Name</th>
                        <th class="bold">Gender</th>
                        <!-- <th class="bold">Date of Birth</th> -->
                        <th class="bold">Age (Yrs)</th>
                        <th class="bold">Relation Ship</th>
                      </tr>
                      <tr
                        v-for="member in personalDetails.UserFamily"
                        :key="member.FamilyID"
                      >
                        <td>{{ member.FullName }}</td>
                        <td v-if="member.Gender">Male</td>
                        <td v-else>Female</td>
                        <!-- <td>{{member.DOBstr}}</td> -->
                        <td>{{ member.Age }}</td>
                        <td>{{ member.ReletionshipName }}</td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <!-- family details ends here -->

      <!-- <div class="reg-form-box" style="">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Bank Details</h5>

                  <table class="profile-table">
                    <tbody>
                      <tr>
                        <td><span class="bold">Bank Accept: </span>{{personalDetails.UserBankDetails.BankAccept}}</td>
                        <td><span class="bold">Bank Name: </span>{{personalDetails.UserBankDetails.BankName}}</td>
                        <td><span class="bold">Branch Name: </span>{{personalDetails.UserBankDetails.BranchName}}</td>
                      </tr>
                      <tr>
                        <td><span class="bold">City: </span>{{personalDetails.UserBankDetails.City}}</td>
                        <td><span class="bold">Comment: </span>{{personalDetails.UserBankDetails.Comment}}</td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>

            </b-row>
          </b-container>
        </div>
      </div>-->

      <!-- bank account start here -->
      <div class="reg-form-box" style>
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Bank Account</h5>
                  <table class="profile-table" style="margin-left: 0">
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">Bank Account No:</span>
                          {{ personalDetails.UserBankAccount.BankAccountNo }}
                        </td>
                        <td>
                          <span class="bold">Bank IFSC Code:</span>
                          {{ personalDetails.UserBankAccount.BankIfscCode }}
                        </td>
                        <td>
                          <span class="bold">Bank Name:</span>
                          {{ personalDetails.UserBankAccount.BankName }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Branch Name:</span>
                          {{ personalDetails.UserBankAccount.BranchName }}
                        </td>
                        <td>
                          <span class="bold">City:</span>
                          {{ personalDetails.UserBankAccount.City }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <!-- bank account ends here -->
      <div class="reg-form-box" style>
        <div class="reg-form-body">
          <b-container class="bv-example-row" v-if="this.LoanType == 1">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">
                    Lending Loan Details
                  </h5>

                  <table class="profile-table" style="margin-left: 0">
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">Organization Name:</span>
                          {{
                            personalDetails.UserLendingLoanDetails
                              .OrganizationName
                          }}
                        </td>
                        <td>
                          <span class="bold">Organization Address:</span>
                          {{
                            personalDetails.UserLendingLoanDetails
                              .OrganizationAddress
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Product From Organization:</span>
                          {{
                            personalDetails.UserLendingLoanDetails
                              .ProductfromOrganization
                          }}
                        </td>
                        <td>
                          <span class="bold">Amount From Bank:</span>
                          {{
                            personalDetails.UserLendingLoanDetails
                              .AmountFromBank
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Bank Name:</span>
                          {{ personalDetails.UserLendingLoanDetails.BankName }}
                        </td>
                        <td>
                          <span class="bold">Branch:</span>
                          {{ personalDetails.UserLendingLoanDetails.Branch }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
          <b-container class="bv-example-row" v-if="this.LoanType == 3">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">
                    Lending Loan Details
                  </h5>

                  <table class="profile-table" style="margin-left: 0">
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">Institute Name:</span>
                          {{
                            personalDetails.UserLendingLoanDetails
                              .OrganizationName
                          }}
                        </td>
                        <td>
                          <span class="bold">Institute Address:</span>
                          {{
                            personalDetails.UserLendingLoanDetails
                              .OrganizationAddress
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Course Name:</span>
                          {{
                            personalDetails.UserLendingLoanDetails
                              .ProductfromOrganization
                          }}
                        </td>
                        <td>
                          <span class="bold">Amount From Bank:</span>
                          {{
                            personalDetails.UserLendingLoanDetails
                              .AmountFromBank
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Bank Name:</span>
                          {{ personalDetails.UserLendingLoanDetails.BankName }}
                        </td>
                        <td>
                          <span class="bold">Branch:</span>
                          {{ personalDetails.UserLendingLoanDetails.Branch }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <div class="reg-form-box" style>
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">
                    Documents Uploaded
                  </h5>
                  <table class="profile-table doc-table" style="margin-left: 0">
                    <tr>
                      <th>Sr No</th>
                      <th>Document Type</th>
                      <th>Value</th>
                      <th>Link</th>
                    </tr>
                    <tr>
                      <td>01.</td>
                      <td>Photo</td>
                      <td></td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.PhotoPath == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.PhotoPath != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.PhotoPath
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>02.</td>
                      <td>PAN Card</td>
                      <td>
                        <span v-if="!editList.ePan">
                          {{ personalDetails.PanCardNo }}
                          <b-btn
                            class="float-right"
                            variant="link"
                            @click="EditField('ePan')"
                          >
                            <i
                              class="fa fa-edit"
                              style="font-size: 14px; color: red"
                            ></i>
                          </b-btn>
                        </span>
                        <span v-if="editList.ePan">
                          <b-input-group>
                            <b-form-input
                              type="text"
                              v-model="personalDetails.PanCardNo"
                              :state="validatePan"
                              size="sm"
                              placeholder="PAN 10 digit"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-btn
                                size="sm"
                                @click="EditField('ePan')"
                                variant="primary"
                              >
                                <i
                                  class="fa fa-save"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                              <b-btn
                                size="sm"
                                @click="CloseField('ePan')"
                                variant="info"
                              >
                                <i
                                  class="fa fa-times"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </span>
                      </td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.PancardPath == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.PancardPath != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.PancardPath
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>03.</td>
                      <td>AdharCard</td>
                      <td>
                        <span v-if="!editList.eAadhar">
                          {{ personalDetails.AdharNo }}
                          <b-btn
                            class="float-right"
                            variant="link"
                            @click="EditField('eAadhar')"
                          >
                            <i
                              class="fa fa-edit"
                              style="font-size: 14px; color: red"
                            ></i>
                          </b-btn>
                        </span>
                        <span v-if="editList.eAadhar">
                          <b-input-group>
                            <b-form-input
                              type="text"
                              :state="validateAadhar"
                              size="sm"
                              placeholder="Aadhar Number 12 digit"
                              v-model="personalDetails.AdharNo"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-btn
                                size="sm"
                                @click="EditField('eAadhar')"
                                variant="primary"
                              >
                                <i
                                  class="fa fa-save"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                              <b-btn
                                size="sm"
                                @click="CloseField('eAadhar')"
                                variant="info"
                              >
                                <i
                                  class="fa fa-times"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </span>
                      </td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.AddharCardPath ==
                            ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.AddharCardPath !=
                            ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.AddharCardPath
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>04.</td>
                      <td>Adhar Card BackSide</td>
                      <td></td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .AddharCardBackPath == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .AddharCardBackPath != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments
                                  .AddharCardBackPath
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>05.</td>
                      <td>RationCard</td>
                      <td>
                        <span v-if="!editList.eRation">
                          {{ personalDetails.RationCardNo }}
                          <b-btn
                            class="float-right"
                            variant="link"
                            @click="EditField('eRation')"
                          >
                            <i
                              class="fa fa-edit"
                              style="font-size: 14px; color: red"
                            ></i>
                          </b-btn>
                        </span>
                        <span v-if="editList.eRation">
                          <b-input-group>
                            <b-form-input
                              size="sm"
                              placeholder="Ration Card Number"
                              type="text"
                              v-model="personalDetails.RationCardNo"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-btn
                                size="sm"
                                @click="EditField('eRation')"
                                variant="primary"
                              >
                                <i
                                  class="fa fa-save"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                              <b-btn
                                size="sm"
                                @click="CloseField('eRation')"
                                variant="info"
                              >
                                <i
                                  class="fa fa-times"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </span>
                      </td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.RationCardPath ==
                            ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.RationCardPath !=
                            ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.RationCardPath
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>06.</td>
                      <td>Ration Card Last Page</td>
                      <td>{{ personalDetails.RationCardNo }}</td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .RationCardLastPath == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .RationCardLastPath != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments
                                  .RationCardLastPath
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>07.</td>
                      <td>Caste Certificate</td>
                      <td>
                        <span v-if="!editList.eCaste">
                          {{ personalDetails.CasteName }}
                          <b-btn
                            class="float-right"
                            variant="link"
                            @click="EditField('eCaste')"
                          >
                            <i
                              class="fa fa-edit"
                              style="font-size: 14px; color: red"
                            ></i>
                          </b-btn>
                        </span>
                        <span v-if="editList.eCaste">
                          <b-input-group>
                            <!-- <b-form-select v-model ="personalDetails.CasteName" :options="Caste"></b-form-select> -->
                            <b-form-select
                              id="exampleInput5"
                              :options="Caste"
                              value-field="CasteID"
                              text-field="CasteName"
                              required
                              size="sm"
                              v-model="CasteID"
                            ></b-form-select>
                            <b-input-group-append>
                              <b-btn
                                size="sm"
                                @click="EditField('eCaste')"
                                variant="primary"
                              >
                                <i
                                  class="fa fa-save"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                              <b-btn
                                size="sm"
                                @click="CloseField('eCaste')"
                                variant="info"
                              >
                                <i
                                  class="fa fa-times"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </span>
                      </td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.CastCertificate ==
                            ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.CastCertificate !=
                            ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments
                                  .CastCertificate
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>08.</td>
                      <td>Birth Certificate</td>
                      <td>
                        <span v-if="!editList.eDOB">
                          {{ personalDetails.DOB }}
                          <b-btn
                            class="float-right"
                            variant="link"
                            @click="EditField('eDOB')"
                          >
                            <i
                              class="fa fa-edit"
                              style="font-size: 14px; color: red"
                            ></i>
                          </b-btn>
                        </span>
                        <span v-if="editList.eDOB">
                          <!-- <b-input-group> -->
                          <!-- <b-form-input type="date" v-model ="personalDetails.DOB"></b-form-input> -->
                          <date-picker
                            v-model="DOB"
                            :state="validateAge"
                            format="DD-MM-YYYY"
                            lang="en"
                            required
                            size="small"
                          ></date-picker>
                          <!-- <b-input-group-append> -->
                          <b-btn
                            size="sm"
                            @click="EditField('eDOB')"
                            variant="primary"
                          >
                            <i
                              class="fa fa-save"
                              style="color: white; font-size: 16px"
                            ></i>
                          </b-btn>
                          <b-btn
                            size="sm"
                            @click="CloseField('eDOB')"
                            variant="info"
                          >
                            <i
                              class="fa fa-times"
                              style="color: white; font-size: 16px"
                            ></i>
                          </b-btn>
                          <label class="ml-2"
                            >Age: {{ personalDetails.Age }}</label
                          >
                          <!-- </b-input-group-append> -->
                          <!-- </b-input-group> -->
                        </span>
                      </td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .BirthCertificate == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .BirthCertificate != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments
                                  .BirthCertificate
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>09.</td>
                      <td>Residance Address</td>
                      <td></td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .ResidentialProofPath == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .ResidentialProofPath != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments
                                  .ResidentialProofPath
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>10.</td>
                      <td>Domicile Certificate</td>
                      <td></td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .DomicileCertificate == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .DomicileCertificate != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments
                                  .DomicileCertificate
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>11.</td>
                      <td>Income Certificate</td>
                      <td></td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .IncomeCertificatePath == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .IncomeCertificatePath != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments
                                  .IncomeCertificatePath
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>12.</td>
                      <td>Bank Account Proof</td>
                      <td>
                        <span v-if="!editList.eAccount">
                          {{ personalDetails.UserBankAccount.BankAccountNo }}
                          <b-btn
                            class="float-right"
                            variant="link"
                            @click="EditField('eAccount')"
                          >
                            <i
                              class="fa fa-edit"
                              style="font-size: 14px; color: red"
                            ></i>
                          </b-btn>
                        </span>
                        <span v-if="editList.eAccount">
                          <b-input-group>
                            <b-form-input
                              type="text"
                              v-model="
                                personalDetails.UserBankAccount.BankAccountNo
                              "
                            ></b-form-input>
                            <b-input-group-append>
                              <b-btn
                                size="sm"
                                @click="EditField('eAccount')"
                                variant="primary"
                              >
                                <i
                                  class="fa fa-save"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                              <b-btn
                                size="sm"
                                @click="CloseField('eAccount')"
                                variant="info"
                              >
                                <i
                                  class="fa fa-times"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </span>
                      </td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.BankAccount == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.BankAccount != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.BankAccount
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.UserLoanDocuments.OtherDocument != ''">
                      <td>13.</td>
                      <td>Other Documents</td>
                      <td></td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.OtherDocument ==
                            ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.OtherDocument !=
                            ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.OtherDocument
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.UserLoanDocuments.Other4 != ''">
                      <td>14.</td>
                      <td>DBSC Approval Letter</td>
                      <td></td>
                      <td>
                        <span
                          v-if="personalDetails.UserLoanDocuments.Other4 == ''"
                          >Not Uploaded</span
                        >
                        <span
                          v-if="personalDetails.UserLoanDocuments.Other4 != ''"
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.Other4
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.UserLoanDocuments.Other2 != ''">
                      <td>14.</td>
                      <td>
                        {{ personalDetails.UserLoanDocuments.Other2Name }}
                      </td>
                      <td></td>
                      <td>
                        <span
                          v-if="personalDetails.UserLoanDocuments.Other2 == ''"
                          >Not Uploaded</span
                        >
                        <span
                          v-if="personalDetails.UserLoanDocuments.Other2 != ''"
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.Other2
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.UserLoanDocuments.Other3 != ''">
                      <td>15.</td>
                      <td>
                        {{ personalDetails.UserLoanDocuments.Other3Name }}
                      </td>
                      <td></td>
                      <td>
                        <span
                          v-if="personalDetails.UserLoanDocuments.Other3 == ''"
                          >Not Uploaded</span
                        >
                        <span
                          v-if="personalDetails.UserLoanDocuments.Other3 != ''"
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.Other3
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.UserLoanDocuments.Other4 != ''">
                      <td>16.</td>
                      <td>
                        {{ personalDetails.UserLoanDocuments.Other4Name }}
                      </td>
                      <td></td>
                      <td>
                        <span
                          v-if="personalDetails.UserLoanDocuments.Other4 == ''"
                          >Not Uploaded</span
                        >
                        <span
                          v-if="personalDetails.UserLoanDocuments.Other4 != ''"
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.Other4
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <div class="reg-form-box">
        <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>

        <b-container class="bv-example-row">
          <b-row>
            <b-col cols="10" offset="1">
              <h5 class="reg-form-title text-primary">Approval History</h5>
              <b-table
                show-empty
                selectable
                select-mode="multi"
                head-variant="dark"
                empty-text="No Applications available."
                stacked="md"
                bordered
                striped
                :items="approvalRemarks"
                :fields="approvalFields"
                variant="dark"
                style="font-size: 12px"
              ></b-table>
            </b-col>
          </b-row>
          <b-row
            class="mt-3"
            v-if="personalDetails.LoanApplication[0].ApprovalDoc != ''"
          >
            <b-col cols="8" offset="1">
              <p>
                <b>DBSC Approval Status</b>
                : {{ personalDetails.LoanApplication[0].ApprovalStatus }}
                <a
                  class="ml-2"
                  target="_blank"
                  :href="
                    getImgUrl2(personalDetails.LoanApplication[0].ApprovalDoc)
                  "
                  >View Approval Report</a
                >
              </p>
              <p>
                <b>Meeting Date</b>
                :
                {{
                  personalDetails.LoanApplication[0].MeetingDate | formatDate
                }}
              </p>
            </b-col>
          </b-row>
        </b-container>
        <b-container class="bv-example-row" v-if="showHistory">
          <b-row>
            <b-col cols="10" offset="1">
              <h5 class="reg-form-title text-primary">
                Approval History of Rejected Applications
                <b-btn variant="link" aria-controls="collapse-4"
                  @click="visible = !visible">Show</b-btn>
              </h5>
              <b-collapse
                id="collapse-4" v-model="visible"
              >
                <b-table
                  show-empty
                  selectable
                  select-mode="multi"
                  head-variant="dark"
                  empty-text="No Applications available."
                  stacked="md"
                  bordered
                  striped
                  :items="approvalRemarksLink"
                  :fields="approvalLinkFields"
                  variant="dark"
                  style="font-size: 12px"
                ></b-table>
              </b-collapse>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- Printme id ends here -->

    <div class="reg-form-box">
      <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
      <b-alert
        :show="showDismissibleAlert"
        dismissible
        @dismissed="showDismissibleAlert = false"
        :variant="variant"
        >{{ alertText }}</b-alert
      >
      <!-- <b-form @submit="onSubmit" class="hide-print" v-if="(
        ApplicationStatus==15 && RoleID==2) || (ApplicationStatus==1 && RoleID==2) || (ApplicationStatus==5 && RoleID==2) ||
        (ApplicationStatus==3 && RoleID==2) || (ApplicationStatus==13 && RoleID==3) || (ApplicationStatus==17 && RoleID==3) ||
        (ApplicationStatus==19 && RoleID==3) ||
      (ApplicationStatus==4 && RoleID==5) || (ApplicationStatus==16 && RoleID==4) || (ApplicationStatus==7 && RoleID==5)">-->
      <b-form @submit="onSubmit" class="hide-print" v-if="showApproval">
        <div class="form-row">
          <div class="form-group col-md-1"></div>
          <div class="form-group col-md-4">
            <!--<label for="ipDistrict" size="sm">District</label> -->
            <b-form-group
              id="fieldset-horizontal"
              label-cols-sm="4"
              label-cols-lg="4"
              label="Approve Application"
              label-for="ipDistrict"
              label-size="sm"
            >
              <b-select
                id="ipDistrict"
                :options="ApprovalStatus"
                value-field="StatusID"
                text-field="Status"
                required
                size="sm"
                @change.native="checkReject"
                v-model="form.ApplicationStatus"
                class="form-control"
              ></b-select>
            </b-form-group>
          </div>
          <div class="form-group col-md-1"></div>
          <div class="form-group col-md-4">
            <b-form-group
              id="fieldset-horizontal2"
              label-cols-sm="4"
              label-cols-lg="4"
              label="Reject Reason"
              label-for="ipReason"
              label-size="sm"
            >
              <!-- <b-select id="ipReason"
                :options="RejectReasons"
                value-field="RejectedID"
                text-field="RejectedTypeName"
                required
                size="sm"
                :disabled="form.ApplicationStatus!=3 && form.ApplicationStatus !=5 && form.ApplicationStatus !=7 && form.ApplicationStatus !=17 && form.ApplicationStatus !=18"
                v-model="form.RejectReason"
              class="form-control">-->
              <b-select
                id="ipReason"
                :options="RejectReasons"
                value-field="RejectedID"
                text-field="RejectedTypeName"
                required
                size="sm"
                :disabled="!isReject"
                v-model="form.RejectReason"
                class="form-control"
              ></b-select>
            </b-form-group>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-1"></div>
          <div class="form-group col-md-9" style="text-align: left">
            <!--<label for="ipDistrict" size="sm">District</label> -->
            <b-form-group
              id="fieldset-horizontal"
              label-cols-sm="4"
              label-cols-md="1"
              label="Remarks"
              label-for="ipRemarks"
              label-size="sm"
            >
              <!-- <b-form-textarea id="ipRemarks"
                v-model="form.Remarks"
                :required="form.ApplicationStatus==3 && form.ApplicationStatus ==5 && form.ApplicationStatus ==7 && form.ApplicationStatus ==17"
                size="sm"
                rows=2, max-rows="4"
              placeholder="Remarks">-->
              <b-form-textarea
                id="ipRemarks"
                v-model="form.Remarks"
                :required="isReject"
                size="sm"
                rows="2,"
                max-rows="4"
                placeholder="Remarks"
              ></b-form-textarea>
            </b-form-group>
          </div>
        </div>
        <b-col style="text-align: center" class="mb-3">
          <b-button
            class="hide-print"
            type="submit"
            variant="primary"
            v-if="showButton"
            >Submit</b-button
          >
        </b-col>
      </b-form>
      <div class="text-center">
        <b-button
          class="hide-print"
          @click.prevent="goback"
          variant="secondary"
          size="small"
          >BACK</b-button
        >
      </div>
    </div>
    <b-modal ref="loiModal" size="xl" hide-footer title="LOI">
      <LoanLOIPrint
        :ApplicationID="form.ApplicationID"
        :Loantype="this.LoanType"
        :UserID="UserID"
        :PastLOI="PastLOI"
        :ApplicantCasteName="personalDetails.CasteName"
        :ApplicantCasteCode="personalDetails.CasteID"
      ></LoanLOIPrint>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import vueHtmlToPaper from "vue-html-to-paper";
import DatePicker from "vue2-datepicker";
import Formatter from "@/Formatter.js";
import Spinner from "vue-simple-spinner";
import LoanLOIPrint from "@/components/RegistrationLoan/LoanLOIPrint";
import { detectTenant, filterCasteDropdown } from "@/tenantConfig";

export default {
  components: { Spinner, DatePicker, LoanLOIPrint },
  props: ["UserID", "ApplicationStatus"],
  data() {
    return {
      visible: true,
      showButton: true,
      showApproval: false,
      isReject: false,
      required: false,
      Caste: [],
      CasteID: "",
      PastLOI: false,
      personalDetails: {
        UserID: null,
        Salutation: null,
        FullName: null,
        FirstName: "",
        MiddleName: "",
        LastName: "",
        DOB: null,
        Age: 38,
        PlaceOfBirth: "",
        Gender: true,
        MotherName: "",
        MobileNo: "",
        MobileNo1: null,
        LandlineNo: null,
        MaritalStatus: true,
        MotherToungue: true,
        EmailID: "",
        Nationality: true,
        Domiciled: true,
        MotherToung: "Hindi",
        AdharNo: "",
        PanCardNo: "",
        CategoryType: null,
        BoardID: "a1bfdfd8-db30-4d39-87f7-5f2eddd7f810",
        RegistrationType: 2,

        LoginID: "00000000-0000-0000-0000-000000000000",
        ApplicationID: "00000000-0000-0000-0000-000000000000",

        LockProfile: true,
        RegistrationTypeName: "",
        BoardName: "",
        PermanentAddress: {
          StateID: "bb62f7b0-748d-4e64-ad4f-8ef691431fa1",
          DistrictID: "8de132b0-61d8-45f6-a953-ea3e9dff25e2",
          TalukaID: "f6cd7bd0-3d6e-4551-83ff-f57db3fd0ee5",
          HouseNo: "",
          BuildingNo: "",
          Street: "",
          Locality: "",
          Landmark: "",
          Village: "",
          Pincode: 400612,
          Post: "",
          StateName: "",
          DistrictName: "",
          TalukaName: "",
        },

        CorrespondenceAddress: {
          StateID: "bb62f7b0-748d-4e64-ad4f-8ef691431fa1",
          DistrictID: "8de132b0-61d8-45f6-a953-ea3e9dff25e2",
          TalukaID: "f6cd7bd0-3d6e-4551-83ff-f57db3fd0ee5",
          HouseNo: "",
          BuildingNo: "",
          Street: "",
          Locality: "",
          Landmark: "",
          Village: "",
          Pincode: 0,
          Post: "",
          ResidanceSince: 1,
          StateName: "Maharashtra",
          DistrictName: "Thane",
          TalukaName: "Thane",
        },
        UserBankAccount: {
          BankAccept: true,
          BankID: "f6cd7bd0-3d6e-4551-83ff-f57db3fd0ee5",
          BankName: "",
          BranchName: "",
          City: "",
          Comment: "",
          BankAccountNo: "",
          BankIfscCode: "",
        },
        UserLendingLoanDetails: {
          AmountFromBank: "",
          LoanDistrict: "",
          OrganizationAddress: "",
          OrganizationName: "",
          ProductfromOrganization: "",
          UserLendingLoanID: "",
        },
        UserPhysicalDetails: {
          UserPhysicalID: null,
          IndetificationMark: "",
          Height: 188,
          Weight: 85,
          ChestDeflated: 100,
          ChestInflated: 105,
        },
        UserQualification: {
          QualificationTypeID: "09713307-253d-4e35-aca9-50ccde3e05a6",
          DegreeID: "03c001dc-b65e-4b96-bd25-f4e425c7fab6",
          StateID: "6e394345-c136-4618-9258-d3bd530fd97b",
          BoardID: "80d06c9d-8256-4b83-ad87-620debf38d32",
          Result: 1,
          Percentage: 66.0,
          Class: "First Class",
          QualificationType: {
            QualificationTypeID: null,
            QualificationTypeName: "Graduate",
          },
          DegreeType: {
            DegreeTypeID: null,
            DegreeName: "B.A.",
            QaulificaitonTypeID: "00000000-0000-0000-0000-000000000000",
          },
          UserState: {
            StateID: "00000000-0000-0000-0000-000000000000",
            StateName: "Bihar",
          },
          EducationBoard: {
            BoardID: null,
            BoardName: "",
            InstituteType: null,
            StateID: "00000000-0000-0000-0000-000000000000",
          },
        },
        UserLoanDocuments: {
          AddharCardPath: null,
          AddharCardPath: null,
          BirthCertificate: null,
          CastCertificate: null,
          CasteCertificate: null,
          CourtOrder: null,
          DeceasedID: null,
          EduCertificate: null,
          ExServiceManProof: null,
          ExprienceCertificate: null,
          FinalDuesLetter: null,
          IncomeTaxApplication: null,
          LegalHireNOC: null,
          MedicalCertificate: null,
          OtherDocument: null,
          PFDeclaration: null,
          PancardPath: null,
          PersonResolutionPath: null,
          PhotoPath: null,
          PoliceVerification: null,
          RationCardPath: null,
          RecommendationLetter: null,
          RegCopy: null,
          ResidentialProofPath: null,
          SignaturePath: null,
          IncomeCertificatePath: null,
        },
        UserDocuments: {
          PhotoPath: null,
          SignaturePath: null,
          AddharCardPath: null,
          PancardPath: null,
          RationCardPath: null,
          CasteCertificate: null,
          EduCertificate: null,
          ExServiceManProof: null,
          ExprienceCertificate: null,
          BirthCertificate: null,
          PoliceVerification: null,
          MedicalCertificate: null,
          RecommendationLetter: null,
          DeceasedID: null,
          LegalHireNOC: null,
          FinalDuesLetter: null,
          CourtOrder: null,
        },
        UserEmergencyContact: {
          ContactName: "",
          Address: "",
          MobileNo: "",
        },
        UserOtherDetails: {
          WorkingYears: "",
          EmployerName: "",
          LoadCapcity: "",
          UnionName: "",
          AccidentHistory: "",
          MedicallyFit: "",
          CriminalCase: "",
          ToliName: "",
          ToliNumber: "",
        },
        UserReligionCaste: {
          ReligionID: "d3f6b84b-c005-474d-aff9-dd27fa763ebc",
          CategoryID: "d25679fb-92ea-434d-a0f8-65b3290c7a8b",
          ReligionName: null,
          CategoryType: null,
          SubCaste: "",
        },
        UserEmploymentExchange: {
          EmploymentName: null,
          EmploymentRegNo: null,
          EmploymentExchangeStatus: false,
        },
        UserDecleration: {
          UserID: "00000000-0000-0000-0000-000000000000",
          ConfirmStatus: false,
          DeclerationText: null,
        },
        ApplyForJob: {
          ApplicationID: "00000000-0000-0000-0000-000000000000",
          JobId: "00000000-0000-0000-0000-000000000000",
          UserID: "00000000-0000-0000-0000-000000000000",
          Status: 0,
          PersonalDetail: false,
          AddressDetail: false,
          OtherDetail: false,
          ExprienceDetail: false,
          QualificationDetail: false,
          DocumentUpload: false,
          DeclerationDetail: false,
          PaymentStatus: false,
          ApplicationNo: null,
        },
        UserApplication: [],
        UserEvaluation: {
          ApplicationID: "00000000-0000-0000-0000-000000000000",
          BatchID: "00000000-0000-0000-0000-000000000000",
          RunningMark: 0,
          PullUps: 0,
          Situps: 0,
          EducationalMarks: 0,
          Height: 0,
          Weight: 0,
          ChestDeflated: 0,
          ChestInflated: 0,
        },
        UserDocumentReview: {
          Review: false,
          Comments: null,
          ApplicationID: "00000000-0000-0000-0000-000000000000",
        },
        UserDocumentUpload: {
          ApplicantPhotoStatus: false,
          ApplicantSignatureStatus: false,
          AdharCardStatus: false,
          RationCardStatus: false,
          DOBCertificateStatus: false,
          CasteCertificateStatus: false,
          DegreeCertificateStatus: false,
          ExprienceCertificateStatus: false,
          ExServiceManCertificateStatus: false,
        },
        UserDocuments: {
          PhotoPath: "",
          SignaturePath: "",
          AddharCardPath: "",
          PancardPath: "",
          RationCardPath: "",
          CasteCertificate: "",
          EduCertificate: "",
          ExServiceManProof: "",
          ExprienceCertificate: "",
          BirthCertificate: "",
          RecommendationLetter: "",
          CourtOrder: "",
          DeceasedID: "",
          LegalHireNOC: "",
          FinalDuesLetter: "",
        },
        UserNominee: [
          {
            NomineeID: "2ff23306-0f82-4613-8197-1aff4533d8b1",
            NomineeName: "",
            Gender: false,
            DOB: "",
            ReletionShip: 3,
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000",
          },
        ],
        UserProfileStatus: {
          PersonalDetail: false,
          AddressDetail: false,
          PhysicalDetail: false,
          NomineeDetail: false,
          ExprienceDetail: false,
          QualificationDetail: false,
          DocumentUpload: false,
          DeclerationDetail: false,
          PaymentStatus: false,
          FamilyDetail: false,
        },
        LoanApplication: [
          {
            LoanType: "",
            UserID: "",
            LoanApplicationID: "",
            LoanApplicationNo: "",
            SchemeType: "",
            GroupID: "",
            AmountDemanded: "",
            ApplicationStatus: "",
            AmountApproved: "",
            Level1Approver: "",
            Level1ApprovalDate: "",
            Level2Approver: "",
            Level2ApprovalDate: "",
            LOIDate: "",
            BankID: "",
            BankApprovalDate: "",
            BankLoanAmount: "",
            BankInterestRate: "",
            LoanTenure: "",
            LoanStartDate: "",
            LoanEndDate: "",
            LoanStatus: "",
          },
        ],
        UserFamily: [
          {
            FamilyID: "efc2815c-68ef-4211-b804-2dde92d97522",
            FullName: "",
            Gender: false,
            DOB: "",
            ReletionShipID: "6fce0f55-2fb6-45b3-ad1f-aa6eb9cecae7",
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000",
          },
          {
            FamilyID: "026e72ee-55b9-4fd4-8a58-3e0f96a08ed4",
            FullName: "",
            Gender: true,
            DOB: "2014-06-03T00:00:00",
            ReletionShipID: "435ea13a-01f6-4360-aa7c-eabb5e4a791a",
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000",
          },
          {
            FamilyID: "413f61a2-1b95-49b9-b397-8cc53994f134",
            FullName: "",
            Gender: false,
            DOB: "1983-12-24T00:00:00",
            ReletionShipID: "f57b429f-481e-47f3-a6dd-99acc6456b56",
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000",
          },
        ],
      },
      docObj: {},
      docTbl: [],
      form: {
        ApplicationStatus: 1,
        RejectReason: 0,
        Remarks: "",
        UserID: "",
        ApplicationID: "",
      },
      RoleID: 0,
      ApprovalStatus: [
        //{ StatusID: 1, Status: "Pending" },
        { StatusID: 2, Status: "Verified" },
        { StatusID: 3, Status: "Hold" },
        { StatusID: 19, Status: "Rejected" },
        //{ StatusID: 15, Status: "Scheduled" }
      ],
      approvalRemarks: [],
      approvalRemarksLink: [],
      approvalFields: [
        "ApplicationStatus",
        "RejectionReason",
        "Remarks",
        {
          key: "LogDate",
          label: "Approve/Reject Date",
          formatter: "convertDateFormat",
        },
        "ApproverName",
      ],
      approvalLinkFields: [
        "ApplicationNo",
        "ApplicationStatus",
        "RejectionReason",
        "Remarks",
        {
          key: "LogDate",
          label: "Approve/Reject Date",
          formatter: "convertDateFormat",
        },
        "ApproverName",
      ],
      RejectReasons: [],
      alertText: "",
      variant: "success",
      isLoading: false,
      showDismissibleAlert: false,
      editList: {
        eDOB: false,
        ePan: false,
        eAadhar: false,
        eRation: false,
        eCaste: false,
        eAccount: false,
        eAddress: false,
      },
      DOB: null,
      updateForm: {
        UserID: null,
        LoanApplicationID: null,
        DOB: null,
        Age: null,
        Pan: null,
        Aadhar: null,
        BankAccount: null,
        RationCard: null,
        CasteID: null,
        CreatedUser: null,
      },
      showHistory: false,
    };
  },
  computed: {
    validateAadhar() {
      if (this.personalDetails.AdharNo == null) {
        return false;
      }

      if (this.personalDetails.AdharNo.length == 0) {
        return false;
      } else if (this.personalDetails.AdharNo != null) {
        var adharformat = /^\d{12}$/;
        if (this.personalDetails.AdharNo.match(adharformat)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validatePan() {
      if (this.personalDetails.PanCardNo == null) {
        return false;
      }

      if (this.personalDetails.PanCardNo.length == 0) {
        return false;
      } else if (this.personalDetails.PanCardNo != null) {
        var panformat = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        if (this.personalDetails.PanCardNo.match(panformat)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validateAge() {
      // console.log('1');
      //let age = this.calculateAge(this.form.DOB);

      let age = this.calculateAge(this.DOB);
      this.PersonalDetails.Age = age;
      if (age < 18 || age >= 50) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    checkReject(evt) {
      let id = parseInt(evt.target.value);
      let appStatus = _.filter(this.ApprovalStatus, { StatusID: id });
      if (appStatus) {
        if (appStatus.length > 0) {
          this.isReject = appStatus[0].ISReject;
          if (!this.isReject) {
            this.form.RejectReason = 0;
          }
        }
      }
    },
    goback() {
      //this.$router.back();
      this.$router.push({
        name: "Applications",
        params: {
          userDistrictID: this.$store.getters.getUserDistrict,
          userApprovalStatus: this.$store.getters.getAppStatus,
          userLoanType: 1,
        },
      });
    },
    calculateAge(birthDate) {
      birthDate = new Date(birthDate);
      let incrementDate = new Date(birthDate);
      // console.log(incrementDate);
      let today = new Date();
      let n = 0;
      while (incrementDate < today) {
        n++;
        incrementDate.setYear(incrementDate.getFullYear() + 1);
      }

      return n - 1;
    },
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    onSubmit(evt) {
      evt.preventDefault();
      if (this.form.ApplicationStatus == this.ApplicationStatus) {
        return;
      }

      let promise = apis.UpdateApplicationStatus(this.form);

      promise
        .then((response) => {
          if (response.status == 200) {
            //Check the profile completion status
            this.alertText = response.body;
            this.variant = "success";
            this.showDismissibleAlert = true;
            this.isLoading = false;
            this.showButton = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    print() {
      window.print();
      //this.$htmlToPaper("printme");
    },
    edit() {
      this.$router.push("/LoginProfile");
    },
    getImgUrl(pic) {
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          this.UserID +
          "/" +
          pic
        );
      }
    },
    getImgUrl2(pic) {
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/msobcfdc_bsc/" + pic
        );
      }
    },
    EditField(fld) {
      if (this.editList[fld]) {
        switch (fld) {
          case "ePan":
            if (!this.validatePan) {
              this.alertText = "Please verify the PAN";
              this.variant = "warning";
              this.showDismissibleAlert = true;
              this.isLoading = false;
              return;
            }
            this.updateForm.Pan = this.personalDetails.PanCardNo;
            break;
          case "eAadhar":
            if (!this.validateAadhar) {
              this.alertText = "Please verify the Aadhar number";
              this.variant = "warning";
              this.showDismissibleAlert = true;
              this.isLoading = false;
              return;
            }
            this.updateForm.Aadhar = this.personalDetails.AdharNo;
            break;
          case "eRation":
            this.updateForm.RationCard = this.personalDetails.RationCardNo;
            break;
          case "eDOB":
            if (!this.validateAge) {
              this.alertText = "Age Criteria not fulfilled";
              this.variant = "warning";
              this.showDismissibleAlert = true;
              this.isLoading = false;
              return;
            }
            this.updateForm.DOB = Formatter.convertDateFormatYMD(this.DOB);
            this.updateForm.Age = this.age;
            break;
          case "eCaste":
            let casteName = _.filter(this.Caste, { CasteID: this.CasteID });
            this.personalDetails.CasteName = casteName[0].CasteName;
            this.updateForm.CasteID = this.CasteID;
            break;
          case "eAccount":
            this.updateForm.BankAccount =
              this.personalDetails.UserBankAccount.BankAccountNo;
            break;
        }

        // Create clean object - only include non-null fields to avoid backend validation errors
        const dataToSend = {
          UserID: this.UserID,
          LoanApplicationID: this.form.ApplicationID,
          CreatedUser: this.$store.getters.loggedUser.UserId
        };

        // Only add fields that have actual values (not null)
        if (this.updateForm.Pan !== null) dataToSend.Pan = this.updateForm.Pan;
        if (this.updateForm.Aadhar !== null) dataToSend.Aadhar = this.updateForm.Aadhar;
        if (this.updateForm.RationCard !== null) dataToSend.RationCard = this.updateForm.RationCard;
        if (this.updateForm.CasteID !== null) dataToSend.CasteID = this.updateForm.CasteID;
        if (this.updateForm.BankAccount !== null) dataToSend.BankAccount = this.updateForm.BankAccount;
        if (this.updateForm.DOB !== null) {
          dataToSend.DOB = this.updateForm.DOB;
          if (this.updateForm.Age !== null) dataToSend.Age = this.updateForm.Age;
        }

        // Build complete user object with ALL required fields from existing data
        const userDataToUpdate = {
          UserID: this.UserID,
          LoginID: this.UserID,
          FirstName: this.personalDetails.FirstName,
          MiddleName: this.personalDetails.MiddleName,
          LastName: this.personalDetails.LastName,
          Gender: this.personalDetails.Gender,
          PlaceOfBirth: this.personalDetails.PlaceOfBirth || "",
          MobileNo: this.personalDetails.MobileNo,
          EmailID: this.personalDetails.EmailID,
          LandlineNo: this.personalDetails.LandlineNo || "",
          MotherName: this.personalDetails.MotherName,
          AdharNo: this.updateForm.Aadhar || this.personalDetails.AdharNo,
          PanCardNo: this.updateForm.Pan || this.personalDetails.PanCardNo,
          RationCardNo: this.updateForm.RationCard || this.personalDetails.RationCardNo,
          CasteID: this.updateForm.CasteID || this.personalDetails.CasteID,
          MaritalStatus: this.personalDetails.MaritalStatus,
          Nationality: this.personalDetails.Nationality,
          Domiciled: this.personalDetails.Domiciled,
          ReligionID: this.personalDetails.ReligionID || (this.personalDetails.UserReligionCaste && this.personalDetails.UserReligionCaste.ReligionID) || "00000000-0000-0000-0000-000000000000",
          CategoryID: this.personalDetails.CategoryID || (this.personalDetails.UserReligionCaste && this.personalDetails.UserReligionCaste.CategoryID) || "00000000-0000-0000-0000-000000000000",
          SubCategoryID: this.personalDetails.SubCategoryID || (this.personalDetails.UserReligionCaste && this.personalDetails.UserReligionCaste.SubCategoryID) || "00000000-0000-0000-0000-000000000000",
          ExServiceMan: this.personalDetails.ExServiceMan || false,
          Driving: this.personalDetails.Driving || false,
          MotherToung: this.personalDetails.MotherToung || "Marathi",
          Marathi: this.personalDetails.Marathi || false,
          Hindi: this.personalDetails.Hindi || false,
          English: this.personalDetails.English || false,
          Other: this.personalDetails.Other || false,
          BoardID: this.personalDetails.BoardID || "00000000-0000-0000-0000-000000000000",
          FamilyIncome: this.personalDetails.FamilyIncome || 0
        };
        
        // Only add DOB and Age if DOB has a valid value (API requires valid DateTime, not null)
        const dobValue = this.updateForm.DOB || (this.personalDetails.DOB ? Formatter.convertDateFormatYMD(this.personalDetails.DOB) : null);
        if (dobValue && dobValue !== "null-null-null" && dobValue !== "0-0-0") {
          userDataToUpdate.DOB = dobValue;
          userDataToUpdate.Age = this.updateForm.Age || this.personalDetails.Age || 0;
        } else if (this.personalDetails.DOB) {
          // Try to use raw DOB if conversion fails
          userDataToUpdate.DOB = this.personalDetails.DOB;
          userDataToUpdate.Age = this.personalDetails.Age || 0;
        } else {
          // No valid DOB available - use a default date (user's actual DOB should exist in DB)
          userDataToUpdate.DOB = "1990-01-01";
          userDataToUpdate.Age = 34;
        }

        console.log("Sending direct update with complete data:", userDataToUpdate);
        let promiseA = apis.saveUserRegistration(userDataToUpdate);

        promiseA
          .then((response) => {
            console.log("API Response:", response);
            if (response.status == 200 && (response.body == "Data Saved Successfully" || response.body.includes("Success"))) {
              this.alertText = "Data Saved Successfully";
              this.variant = "success";
              this.showDismissibleAlert = true;

              // Update the local CasteName immediately
              if (this.updateForm.CasteID) {
                let casteName = _.filter(this.Caste, { CasteID: this.updateForm.CasteID });
                if (casteName.length > 0) {
                  this.personalDetails.CasteName = casteName[0].CasteName;
                  this.personalDetails.CasteID = this.updateForm.CasteID;
                }
              }

              // Reload profile data to reflect changes
              setTimeout(() => {
                this.reloadProfileData();
              }, 500);
            } else {
              console.error("API Error Response:", response);
              this.alertText = "Error while Updating Data, " + (response.body || response.statusText || "Unknown error");

              this.variant = "warning";
              this.showDismissibleAlert = true;
            }
          })
          .catch((err) => {
            console.error("API Call Failed:", err);
            console.error("Error body:", err.body);
            console.error("Error bodyText:", err.bodyText);
            console.error("Error status:", err.status);
            console.error("Full error:", JSON.stringify(err, null, 2));
            this.alertText = "Error while Updating Data, " + (err.bodyText || err.body || err.message || "Unknown error");
            this.showDismissibleAlert = true;
            this.variant = "danger";
          });
      } else {
        switch (fld) {
          case "eCaste":
            let casteid = _.filter(this.Caste, {
              CasteName: this.personalDetails.CasteName,
            });
            this.CasteID = casteid[0].CasteID;
            break;
        }
      }
      this.editList[fld] = !this.editList[fld];
    },
    CloseField(fld) {
      this.editList[fld] = !this.editList[fld];
    },
    reloadProfileData() {
      // Reload the user profile to reflect the saved changes
      let promiseU = apis.ReadUserDetailByIndivisual(this.UserID);

      promiseU
        .then((response) => {
          if (response.status == 200) {
            console.log("Reloaded profile data:", response.body);
            console.log("Old CasteName:", this.personalDetails.CasteName);
            console.log("New CasteName:", response.body.CasteName);
            this.personalDetails = response.body;
            this.personalDetails.DOB = Formatter.convertDateFormat(response.body.DOB);
            console.log("Profile data reloaded successfully");
          }
        })
        .catch((err) => {
          console.error("Failed to reload profile data:", err);
        });
    },
    getCaste() {
      let promiseA = apis.getCaste();

      promiseA
        .then((response) => {
          if (response.status == 200) {
            //let rspns = response.body;
            this.Caste = filterCasteDropdown(response.body, detectTenant());
          } else {
            this.alertText = "Unable to get caste List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch((err) => {
          this.alertText = "Unable to get caste List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    printLoi() {
      this.PastLOI = false;
      this.$refs["loiModal"].show();
      // this.$router.push({
      //   name: "LoanLOIPrint",
      //   params: { ApplicationID: this.form.ApplicationID, Loantype: 1, UserID: this.UserID }
      // });
    },

    printLoiOld() {
      this.PastLOI = true;
      this.$refs["loiModal"].show();
      // this.$router.push({
      //   name: "LoanLOIPrint",
      //   params: { ApplicationID: this.form.ApplicationID, Loantype: 1, UserID: this.UserID }
      // });
    },
    extendLoi() {
      var appform = {
        ApplicationIDs: [this.form.ApplicationID],
        CreatedUser: this.$store.getters.loggedUser.UserId,
      };

      var t = this;
      this.$dialog
        .prompt(
          {
            title: "Confirm LOI Extension",
            body: "A New LOI will be issued for the selected Application, Do you want to Continue?",
          },
          {
            promptHelp: 'Provide Remarks and click "[+:okText]"',
            okText: "Extend LOI",
            cancelText: "Cancel",
            loader: false,
          }
        )
        .then(function (dialog) {
          if (dialog.data) {
            appform.remarks = dialog.data;
          } else {
            t.$dialog.alert("Please enter Remarks");
            return;
          }
          return apis.ExtendLoi(appform);
        })
        .then((response) => {
          if (response != undefined) {
            if (response.status == 200) {
              this.$dialog.alert(
                "New LOI Issued for the Selected Applications"
              );
              t.getApplicationsSub();
            } else {
              this.$dialog.alert("Unable to save changes");
            }
          }
        })
        .catch((err) => {
          if (err != false) {
            this.$dialog.alert("Error while saving data");
          }
        });

      // let promiseA = apis.ExtendLoi(appform);

      // promiseA
      //   .then(response => {
      //     if (response.status == 200) {
      //       alert("New LOI Issued");
      //       this.alertText = "New LOI Issued";
      //       this.variant = "Success";
      //       this.showDismissibleAlert = true;
      //     }
      //   })
      //   .catch(err => {
      //     this.alertText = "Unable to Save Changes, " + err.message;
      //     this.showDismissibleAlert = true;
      //     this.variant = "danger";
      //   });
    },
  },

  mounted() {
    this.editList = {
      eDOB: false,
      ePan: false,
      eAadhar: false,
      eRation: false,
      eCaste: false,
      eAccount: false,
      eAddress: false,
    };
    this.getCaste();
    var userinfo = this.$store.getters.loggedUser;
    this.RoleID = userinfo.RoleID;
    this.form.ApplicationStatus = this.ApplicationStatus;
    this.showApproval = false;
    let promise = apis.ReadApplicationStatusByRoleStatus({
      Role: userinfo.RoleID,
      Status: this.ApplicationStatus,
    });

    promise
      .then((response) => {
        if (response.status == 200) {
          this.ApprovalStatus = JSON.parse(response.body);
          if (this.ApprovalStatus.length > 0) {
            this.showApproval = true;
          }
        } else {
          this.ApprovalStatus = [];
        }
      })
      .catch((err) => {
        this.ApprovalStatus = [];
        this.alertText = "Error in Loading Application Staus Master";
        this.variant = "danger";
        this.showDismissibleAlert = true;
      });

    // if (this.RoleID == 3) {
    //   this.ApprovalStatus = [
    //     //{ StatusID: 13, Status: "Approved by DBSC" },
    //     { StatusID: 4, Status: "Recommended" },
    //     { StatusID: 5, Status: "Rejected" }
    //   ];

    // } else if (this.RoleID == 2 && this.ApplicationStatus == 5) {
    //   this.ApprovalStatus = [
    //     //{ StatusID: 13, Status: "Approved by DBSC" },
    //     { StatusID: 19, Status: "Verified" },
    //     { StatusID: 3, Status: "Hold" },
    //     { StatusID: 18, Status: "Rejected" }
    //   ];
    // }
    // else if (this.RoleID == 4) {
    //   this.ApprovalStatus = [
    //     //{ StatusID: 16, Status: "Verified by GM" },
    //     { StatusID: 6, Status: "Approved" },
    //     { StatusID: 7, Status: "Rejected" }
    //   ];
    // } else if (this.RoleID == 5) {
    //   this.ApprovalStatus = [
    //     //{ StatusID: 4, Status: "Recommended by HO" },
    //     { StatusID: 16, Status: "Recommended" },
    //     { StatusID: 17, Status: "Rejected" }
    //   ];
    // }

    this.form.UserID = userinfo.UserId;
    let promiseU = apis.ReadUserDetailByIndivisual(this.UserID); //Personal Details

    promiseU
      .then((response) => {
        if (response.status == 200) {
          //console.log(response.body);
          this.personalDetails = response.body;
          this.personalDetails.DOB = Formatter.convertDateFormat(
            response.body.DOB
          );
          this.DOB = Formatter.convertDateFormatYMD(response.body.DOB);
          for (var i = 0; i < response.body.LoanApplication.length; i++) {
            this.LoanType=response.body.LoanApplication[i].LoanType;
            if (response.body.LoanApplication[i].LoanType == 1 || response.body.LoanApplication[i].LoanType == 3) {
              this.personalDetails.LoanApplication[0].LoanApplicationNo =
                response.body.LoanApplication[i].LoanApplicationNo;
              this.form.ApplicationID =
                response.body.LoanApplication[i].LoanApplicationID;

              if (
                this.personalDetails.LoanApplication[0].ApprovalDoc != "" &&
                (this.ApplicationStatus == 3 || this.ApplicationStatus == 1)
              ) {
                this.ApprovalStatus.unshift({
                  StatusID: 19,
                  Status: "Re-Verified by DM",
                });
              }

              let promiseA = apis.ReadApprovalRemarks(this.form.ApplicationID);
              promiseA.then((response) => {
                if (response.status == 200) {
                  this.approvalRemarks = response.body;
                }
              });

              let promiseAL = apis.ReadApprovalRemarksLink(this.UserID);
              promiseAL.then((response) => {
                if (response.status == 200) {
                  this.approvalRemarksLink = response.body;
                  if (this.approvalRemarksLink.length > 0) {
                    this.showHistory = true;
                  }
                }
              });
            }
          }
          this.isLoading = false;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch((err) => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });

    let promiseR = apis.ReadRejectTypes();

    promiseR
      .then((response) => {
        if (response.status == 200) {
          this.RejectReasons = response.body;
        }
      })
      .catch((err) => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  },
};
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  /* border-collapse: collapse; */
  width: 80%;
  margin-left: 10%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 6px;
}
.newfont {
  font-size: 0.875rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/ViewPersonalDetailsProfile.vue